import React, { useEffect, useState } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import type { MenuProps, MenuTheme } from 'antd';
import { Menu, Switch } from 'antd';
import { routes } from 'src/routers';
import { NavLink } from 'react-router-dom';
import SMenu from './SMenu';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import SvgIcon from 'src/components/SvgIcon/SvgIcon';
import cx from 'classnames';
import { getCurrentUserInfo } from 'src/api/login';

import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

type MenuItem = Required<MenuProps>['items'][number];
// import SvgIcon from 'src/views/components/SvgIcon'
import Logo from 'src/assets/img/logo.png';
import styles from '../index.module.less';
// import { AnyObject } from 'yup/lib/object';
// import SMenu from './SMenu'

interface routerItem {
    name: string;
    path: string;
    children: routerItem[];
}

const SideMenu = ({ collapsed, ...props }: { collapsed: boolean }) => {
    const location = useLocation();
    const [sideMenu, setSideMenu] = useState<any[]>([]);
    const [activeMenu, setActiveMenu] = useState<any[]>([]);
    const [userType, setUserType] = useState<string>('');

    useEffect(() => {
        getCurrentUserInfo().then(({ data }) => {
            setUserType(data.userType);
        });
    }, []);

    useEffect(() => {
        // console.log('location', location)
        const matches: any = matchRoutes(routes, location); // 返回匹配到的路由数组对象，每一个对象都是一个路由对象
        const sm = (matches && matches[0].route.children) || [];
        // console.log('matches22222222222', matches, sm)
        setSideMenu(sm);
        // setActiveMenu()
        // 	const matches = matchRoutes(User.menuTree, location)
        const invisible = matches === null || (matches![matches.length - 1] as any).route.hidden;
        // 	const sm = (matches && matches[0].route.children) || []
        const am = (matches || []).map((m: any) => m.pathname);
        // console.log(am, '====am')
        // 	setSideMenu(invisible ? [] : sm)
        setActiveMenu(invisible ? [] : am.slice(1));
        // // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <div className={cx(styles['side-menu-wrapper'], collapsed ? styles['collapsed'] : styles['uncollapsed'])}>
            {/* <div className="side-btn" onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div> */}
            <div className={styles['sidebar-logo-container']}>
                {/* <SvgIcon name='lambda' /> */}
                <img src={Logo} alt="Logo" />
                {!collapsed && <h1>数据维护管理</h1>}
            </div>
            <SMenu sideMenu={sideMenu} activeMenu={activeMenu} collapsed={collapsed} userType={userType} />
        </div>
    );
};

export default SideMenu;
